import {
  CheckboxInput,
  EmptyInput,
  errorsToPropertyErrors,
  FlexColumn,
  Input,
  InputGroup,
  InputRow,
  useModelFormUpdate,
} from '@equifinance/shared';
import styled from 'styled-components';
import { useState } from 'react';
import { ChecklistSection } from '../../ChecklistPage';
import { PaddedGenericSection } from '../GenericSection';
import { Action, useChecklistContext } from '../../../../contexts';

const InputRowWrapper = styled(InputRow)`${({ theme }) => `
  padding-block: 0;
  margin-bottom: -${theme.padding[5]};
`}`;

const ActionsContainer = styled(FlexColumn)`${({ theme }) => `
  gap: ${theme.padding[3]};
`}`;

export default function PostOfferActionsSection() {
  const [actionTouched, setActionTouched] = useState<boolean>(false);
  const { checklist } = useChecklistContext();

  const { postOffer, errors } = checklist ?? {};
  const update = useModelFormUpdate();

  const postOfferActions = postOffer?.actions ?? [];

  const actionsErrors = postOffer?.actions?.map(
    (action) => errors?.[action?.id],
  )?.flat()?.filter((v) => !!v) ?? [];

  const propertyErrors = errorsToPropertyErrors([
    ...actionsErrors,
  ]);

  const onChangeAction = (action: Action) => (value: boolean) => {
    update({
      'postOffer.actions':
        postOffer?.actions?.map((actionItem) => (
          actionItem.id === action.id
            ? { ...actionItem, checked: value }
            : actionItem
        )) ?? [],
    });
  };

  return (
    <PaddedGenericSection
      subSection={ChecklistSection.POST_ACTIONS}
      level={1}
    >
      <InputGroup>
        <InputRowWrapper>
          <Input
            id="post-offer-actions"
            errors={propertyErrors?.checked ?? []}
            hasError={(!!propertyErrors?.checked?.length && actionTouched)}
          >
            <ActionsContainer>
              {postOfferActions?.map((action, actionIndex) => (
                <CheckboxInput
                  id={`${action?.title}-${actionIndex}`}
                  label={action?.title}
                  key={action?.id}
                  value={action?.checked}
                  onChange={onChangeAction(action)}
                  disabled={postOffer?.checklistIndicatorType === 'Locked' || postOffer?.submitted}
                  touchOverride={actionTouched}
                  hasErrorOverride={(!!propertyErrors?.checked?.length && actionTouched)}
                  onBlur={() => setActionTouched(true)}
                />
              ))}
            </ActionsContainer>
          </Input>
          <EmptyInput />
        </InputRowWrapper>
      </InputGroup>
    </PaddedGenericSection>
  );
}
